<template>
  <h5>Detaljeret mandatfordeling</h5>

  <p v-if="!threshold">Beregnet uden spærregrænse.</p>
  <p v-if="threshold">Spærregrænse: {{ threshold }}%</p>

  <p>
    {{ items[0].values.len }}
  </p>

  <table class="table table-hover table-bordered">
    <thead>
      <tr>
        <th class="col-md-2">Parti/liste</th>

        <th
          class="text-center col-md-1"
          v-for="(item, itemIndex) in items[0].values"
          v-bind:key="itemIndex"
        >
          {{ item.partyLetter }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, itemIndex) in items" :key="itemIndex">
        <td>Divideret med {{ item.divisor }} (mandat)</td>

        <td
          class="text-center"
          v-for="(value, valueIndex) in item.values"
          :key="valueIndex"
        >
          <span v-if="value.status !== 3"
            >{{ value.weightRounded }}
            <span
              v-bind:class="{
                'seat-won': value.status === 0,
                'seat-lost': value.status === 1,
                'seat-draw': value.status === 2,
              }"
              >({{ value.seat }})</span
            ></span
          >
        </td>
      </tr>
      <tr></tr>
    </tbody>
  </table>
</template>

<script>


import { HTTP } from '../http-common.js';

export default {
  name: 'DetailedResult',
  props: {
    title: String,
    items: Array,
    parties: Array,
    threshold: Number,
  },
  components: {},
  data: function() {
    return {};
  },
  methods: {
    exportToExcel: function() {
      HTTP.get('/calculations/037f278f-fd90-473f-a9dd-e23e123852f9/export')
        .then(() => {})
        .catch(() => alert('Der opstod en fejl. Data blev ikke eksporteret.'));
    },
  },
};
</script>

<style scoped>
.margin-top {
  margin-top: 30px;
}

.seat-won {
  color: green;
}

.seat-lost {
  color: red;
}

.seat-draw {
  color: orange;
}
</style>
